<div class="dialog" fxLayout="column">

  <div mat-dialog-header>
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div fxLayout="row" fxLayoutGap="10px">
        <mat-icon>today</mat-icon>
        <h1>{{'施設予約状況：閲覧' | translate}}</h1>
      </div>

      <button mat-button (click)="onNoClick()">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </div>

  <div mat-dialog-content>
    <form class="form" [formGroup]="reservationFacilityFormGroup">
      <div class="dialog-body" fxLayout="row" fxLayoutGap="24px">
        <div fxLayout="column" fxLayoutGap="20px" fxFlex="100%">
          <div fxLayout="row" fxLayoutGap="20px">
            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">ID</mat-label>
              <input matInput placeholder="ID" formControlName="reservationFacilityId" maxlength="6" readonly>
            </mat-form-field>

            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">{{'名称' | translate}}</mat-label>
              <input matInput placeholder="{{'名称' | translate}}" value="{{ reservationFacility!.reservation_facility_names | multiName:projectLanguages:projectBaseLang }}" readonly>
            </mat-form-field>
          </div>

          <div fxLayout="row" fxLayoutGap="20px">
            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">{{'対象環境' | translate}}</mat-label>
              <mat-select placeholder="{{'対象環境' | translate}}" formControlName="reservationTarget" (selectionChange)="changeTarget()">
                <mat-option [value]="TARGET_PRODUCTION">{{'本番環境' | translate}}</mat-option>
                <mat-option [value]="TARGET_PREVIEW">{{'プレビュー環境' | translate}}</mat-option>
              </mat-select>
            </mat-form-field>

            <div fxFlex="50%" fxLayout="column">
              <mat-label fxLayout="row" fxLayoutGap="10px">
                <span><button class="reservation-calendar-custom-color-closed-example">1</button>{{'休日' | translate}}</span>
                <span><button class="reservation-calendar-custom-color-full-example">1</button>{{'満席' | translate}}</span>
              </mat-label>
    
              <mat-form-field>
                <mat-label floatLabel="always">{{'利用日' | translate}}</mat-label>
                <input matInput placeholder="{{'利用日' | translate}}" [matDatepicker]="reservationDatePicker" formControlName="reservationDate" [min]="reserveStartDate" [max]="reserveEndDate" (dateChange)="changeDate()" readonly>
                <mat-datepicker-toggle matSuffix [for]="$any(reservationDatePicker)" [disabled]="!targetReservationFacility"></mat-datepicker-toggle>
                <mat-datepicker class="mat-datepicker-content mat-calendar-body-selected mat-calendar-body-cell-content" [dateClass]="dateClass" #reservationDatePicker></mat-datepicker>
              </mat-form-field>
            </div>

          </div>

          <ng-container *ngIf="targetReservationFacility && targetReservationFacility.reservation_unit === 1">
            <table>
              <thead>
                <tr>
                  <th width="50%">{{'予約数' | translate}}</th>
                  <th width="50%">{{'最大予約数' | translate}}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="reservationStatuses.length > 0">
                  <td>{{ reservationStatuses[0].count }}</td>
                  <td>{{ reservationStatuses[0].value }}</td>
                </tr>
              </tbody>
            </table>
          </ng-container>

          <ng-container *ngIf="targetReservationFacility && targetReservationFacility.reservation_unit === 2">
            <table>
              <thead>
                <tr>
                  <th width="34%">{{'時間枠' | translate}}</th>
                  <th width="33%">{{'予約数' | translate}}</th>
                  <th width="33%">{{'最大予約数' | translate}}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let status of reservationStatuses">
                  <td>{{ status.start_time + ' - ' + status.end_time }}</td>
                  <td>{{ status.count }}</td>
                  <td>{{ status.value }}</td>
                </tr>
              </tbody>
            </table>
          </ng-container>

        </div>
      </div>
    </form>
  </div>

</div>
